/** Bearbeitungs-Templates der Rechnungs-View — Port von `IwmEditColumnsRechnung.razor`. */

import type { Receipt } from '@/types/entities';
import {
  rechnungArtAufteilungDisplayNames,
  rechnungsartDisplayNames,
  type RechnungArtAufteilung,
  type Rechnungsart,
} from '@/types/enums';

import type { CellTemplateMap } from '../types';
import { EnumEditor } from './EnumEditor';

export const receiptEditTemplates: CellTemplateMap<Receipt> = {
  Rechnungsart: (model) => (
    <EnumEditor<Rechnungsart>
      value={model.Rechnungsart}
      displayNames={rechnungsartDisplayNames}
      onCommit={(value) => {
        model.Rechnungsart = value;
      }}
    />
  ),
  ArtAufteilung: (model) => (
    <EnumEditor<RechnungArtAufteilung>
      value={model.ArtAufteilung}
      displayNames={rechnungArtAufteilungDisplayNames}
      onCommit={(value) => {
        model.ArtAufteilung = value;
      }}
    />
  ),
};

export default receiptEditTemplates;
